import React, { useEffect, useRef } from 'react';
import { useAuth } from './contexts/AuthContext';
import AppRouter from './components/routing/AppRouter';

function App() {
  const { user, logout } = useAuth();
  const prevUserIdRef = useRef('__INITIAL__');

  // Listen for unauthorized events (401 errors from API)
  useEffect(() => {
    const handleUnauthorized = () => {
      logout();
    };

    window.addEventListener('auth:unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('auth:unauthorized', handleUnauthorized);
    };
  }, [logout]);

  // Dispatch custom event when user changes (for resetting component state)
  useEffect(() => {
    const currentUserId = user?.id;
    const prevUserId = prevUserIdRef.current;

    // Skip the very first run (initial mount before auth is determined)
    if (prevUserId === '__INITIAL__') {
      prevUserIdRef.current = currentUserId;
      return;
    }

    // If user ID changed (logout, or switching between users)
    if (prevUserId !== currentUserId) {
      if (!currentUserId) {
        // User logged out - dispatch event for components to clear state
        window.dispatchEvent(new CustomEvent('auth:logout'));
      } else if (prevUserId !== null && prevUserId !== undefined) {
        // Different user logged in - dispatch event for components to refresh
        window.dispatchEvent(new CustomEvent('auth:userChanged'));
      }
      // else: Initial login - components will handle their own initial load

      // Update the ref to current user ID
      prevUserIdRef.current = currentUserId;
    }
  }, [user?.id]);

  return <AppRouter />;
}

export default App;
